(function () {
  'use strict';

  var numbers = document.querySelectorAll('[data-apob-number]');
  if (!numbers.length) return;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DIGIT_STAGGER_MS = 180;

  /**
   * Activate the diagonal loop on any arrow that lives in the
   * same stat group as `numberEl`. We toggle the class rather
   * than starting the animation from JS so the timing is owned
   * entirely by CSS (cheaper, easier to tune, GPU-driven).
   *
   * The arrow is decorative (`aria-hidden="true"`), so animating
   * it has no impact on screen-reader output — the percentage's
   * `aria-label` still conveys the value to AT users.
   *
   * Honors `prefers-reduced-motion`: we still add the class so
   * the CSS reduced-motion query can keep the arrow static
   * (rather than relying on the absence of the class, which
   * would also kill the will-change cleanup hook).
   */
  function activateArrow(numberEl) {
    var stat = numberEl.parentNode;
    if (!stat) return;
    var arrow = stat.querySelector('.apob-bergamore__arrow');
    if (!arrow) return;
    arrow.classList.add('is-animating');
  }

  function animate(numberEl) {
    if (numberEl.dataset.apobAnimated) return;
    numberEl.dataset.apobAnimated = '1';

    activateArrow(numberEl);

    var digits = numberEl.querySelectorAll('.apob-digit');
    if (!digits.length) return;

    // Snap every digit to its start position (0 for "up", 9 for "down")
    // without animating. Liquid pre-renders --apob-digit-target at the
    // final offset so the static state (no JS, reduced motion, etc.)
    // already shows the target value — we only reset it when we're
    // actually about to roll.
    digits.forEach(function (digit) {
      digit.style.setProperty('--apob-digit-target', '0');
    });

    // Commit the snap to a paint so the transition has a from-value.
    void numberEl.offsetWidth;

    digits.forEach(function (digit, i) {
      var targetOffset = parseInt(digit.getAttribute('data-target-offset'), 10);
      if (isNaN(targetOffset)) return;

      if (reducedMotion) {
        digit.style.setProperty('--apob-digit-target', String(targetOffset));
        return;
      }

      setTimeout(function () {
        digit.classList.add('apob-digit--animating');
        digit.style.setProperty('--apob-digit-target', String(targetOffset));
      }, i * DIGIT_STAGGER_MS);
    });
  }

  if (!('IntersectionObserver' in window)) {
    numbers.forEach(animate);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animate(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });

  numbers.forEach(function (n) { observer.observe(n); });
})();